export const BACKEND_URL: string = 'https://rohrdemo.synapto.ch/api';
